import type { SvgIconProps } from '../../types/props.ts'

export const QuickFrameIconDark = (props: SvgIconProps) => {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden={true}
      role="img"
      {...props}
    >
      <rect width="48" height="48" rx="6" fill="black" fillOpacity="0.6" />
      <rect
        x="0.5"
        y="0.5"
        width="47"
        height="47"
        rx="5.5"
        stroke="white"
        strokeOpacity="0.1"
      />
      <g filter="url(#filter0_d_11477_18176)">
        <path
          d="M26.4169 23.0255C26.4169 16.9619 22.226 12.3249 16.1039 12.3249C9.88988 12.3249 5.72867 16.9619 5.72867 23.0255C5.72867 29.0891 9.88988 33.7268 16.1039 33.7268C17.423 33.7349 18.7325 33.5031 19.9687 33.0428L21.8711 35.8078L24.2789 34.1425L22.5247 31.6162C24.9607 29.6841 26.4169 26.5931 26.4169 23.0255ZM20.8587 29.238L18.6592 26.0876L16.2521 27.7225L18.3027 30.695C17.588 30.9012 16.8469 31.001 16.1032 30.9914C11.5255 30.9914 8.79085 27.4542 8.79085 23.0247C8.79085 18.5952 11.5247 15.0595 16.1039 15.0595C20.6246 15.0595 23.3569 18.5967 23.3569 23.0255C23.3555 25.5526 22.4639 27.7818 20.8587 29.238Z"
          fill="white"
          fillOpacity="0.6"
        />
        <path
          d="M26.4169 23.0255C26.4169 16.9619 22.226 12.3249 16.1039 12.3249C9.88988 12.3249 5.72867 16.9619 5.72867 23.0255C5.72867 29.0891 9.88988 33.7268 16.1039 33.7268C17.423 33.7349 18.7325 33.5031 19.9687 33.0428L21.8711 35.8078L24.2789 34.1425L22.5247 31.6162C24.9607 29.6841 26.4169 26.5931 26.4169 23.0255ZM20.8587 29.238L18.6592 26.0876L16.2521 27.7225L18.3027 30.695C17.588 30.9012 16.8469 31.001 16.1032 30.9914C11.5255 30.9914 8.79085 27.4542 8.79085 23.0247C8.79085 18.5952 11.5247 15.0595 16.1039 15.0595C20.6246 15.0595 23.3569 18.5967 23.3569 23.0255C23.3555 25.5526 22.4639 27.7818 20.8587 29.238Z"
          fill="url(#paint0_radial_11477_18176)"
        />
        <g filter="url(#filter1_d_11477_18176)">
          <path
            d="M29.074 15.6516H32.1355V15.6457H42.2713V12.9111H29.074V15.6516Z"
            fill="#15D17C"
          />
        </g>
        <path
          d="M29.074 33.7178H32.1355V25.0982H41.0834V22.4391H29.074V33.7178Z"
          fill="white"
          fillOpacity="0.6"
        />
        <path
          d="M29.074 33.7178H32.1355V25.0982H41.0834V22.4391H29.074V33.7178Z"
          fill="url(#paint1_radial_11477_18176)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_11477_18176"
          x="1.72867"
          y="10.3249"
          width="44.5427"
          height="31.4828"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11477_18176"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11477_18176"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_11477_18176"
          x="26.1387"
          y="9.97571"
          width="19.068"
          height="8.61126"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.46768" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.254873 0 0 0 0 0.751624 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11477_18176"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11477_18176"
            result="shape"
          />
        </filter>
        <radialGradient
          id="paint0_radial_11477_18176"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.6418 33.6062) rotate(-89.6853) scale(22.4232 26.9006)"
        >
          <stop stopColor="#16516F" stopOpacity="0.4" />
          <stop offset="1" stopColor="white" stopOpacity="0.7" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_11477_18176"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(34.8285 32.6604) rotate(-89.6197) scale(10.7698 15.6155)"
        >
          <stop stopColor="#16516F" stopOpacity="0.4" />
          <stop offset="1" stopColor="white" stopOpacity="0.7" />
        </radialGradient>
      </defs>
    </svg>
  )
}
